import React, { useState } from "react";
import BrochureForm from "../components/EnquiryForm"; // The pop-up form
import "./MCAProgram.css"; 
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import CTAButtons from "../components/sticky-button";
import PageHeader from "../about/PageHeader";
import ContactAdmissionsStrip from "../components/ContactAdmissionsStrip";

// Icons remain the same as your original code
const TimelineIcon = () => (<svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-feature-svg"><path d="M6 7.5h12" /><path d="M6 12h12" /><path d="M6 16.5h12" /><circle cx="6" cy="7.5" r="1.5" /><circle cx="12" cy="12" r="1.5" /><circle cx="18" cy="16.5" r="1.5" /></svg>);
const RocketIcon = () => (<svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-feature-svg"><path d="M14.5 4.5c2.8.2 5 2.4 5 5-2.4 1.7-4.8 4.1-6.5 6.5-2.6 0-4.5-.8-6.5-2.8 2.4-1.7 4.8-4.1 8-8.7Z" /><path d="M9 15 6 18" /><path d="M6 13c-.8 1.6-.9 3.4-.5 5 .1.5.7.7 1.1.4 1.6-.9 2.9-2.2 3.8-3.8" /><circle cx="15.7" cy="8.3" r="1.2" /></svg>);
const TrendingIcon = () => (<svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-feature-svg"><path d="M4 16.5 9 11.5l3.2 3.2L20 7" /><path d="M14 7h6v6" /></svg>);
const HubIcon = () => (<svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-feature-svg"><circle cx="12" cy="5" r="2.3" /><circle cx="5" cy="17" r="2.3" /><circle cx="19" cy="17" r="2.3" /><path d="M12 7.3v4.2" /><path d="M12 11.5 6.8 14.6" /><path d="M12 11.5l5.2 3.1" /></svg>);
const BiotechIcon = () => (<svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-feature-svg"><path d="M9 3.5c2.5 2 4 4.6 4 7.4A6.5 6.5 0 1 1 6.5 4.4" /><path d="M15 20.5c-2.5-2-4-4.6-4-7.4A6.5 6.5 0 1 1 17.5 19.6" /><path d="M8 8h8" /><path d="M8 12h8" /><path d="M8 16h8" /></svg>);
const BuildingIcon = () => (<svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-stat-svg"><path d="M3 21h18M5 21V7l7-3 7 3v14M8 10h2m-2 4h2m-2 4h2m4-8h2m-4 4h2m-4 4h2" /></svg>);
const UsersIcon = () => (<svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-stat-svg"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm14 10v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></svg>);
const GraduationIcon = () => (<svg viewBox="0 0 24 24" aria-hidden="true" className="mca-ig-stat-svg"><path d="M22 10v6M2 10l10-5 10 5-10 5z" /><path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5" /></svg>);

export default function IntegratedMCAProgram() {
   const [showForm, setShowForm] = useState(false);
  
  // --- ADDED ASSET HELPER FUNCTION ---
  const asset = (path) => `${process.env.PUBLIC_URL}${path.startsWith('/') ? path : `/${path}`}`;

  const keyFeatures = [
    {
      title: "Early Specialization",
      desc: "Start your IT career path right after high school.",
      icon: <TimelineIcon />
    },
    {
      title: "Industry-Aligned Curriculum",
      desc: "Courses are regularly updated in line with current tech trends like AI, Data Science, Cybersecurity, Cloud Computing, and more.",
      icon: <TrendingIcon />
    },
    {
      title: "Cost and Time Efficient",
      desc: "One continuous program reduces the time and cost of pursuing separate degrees.",
      icon: <HubIcon />
    },
    {
      title: "Internships & Projects",
      desc: "Hands-on training through real-world projects and internships in leading IT firms.",
      icon: <RocketIcon />
    },
    {
      title: "Career-Ready Graduates",
      desc: "Equips students with skills in software development, database management, system design, mobile and web applications, and more.",
      icon: <BiotechIcon />
    }
  ];

  return (
    <>
      <Navbar />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <CTAButtons />
      <PageHeader
        title="Integrated MCA"
        crumbs={[{ label: 'Home', href: '/' }, { label: 'Integrated MCA' }]}
      />
      <div className="mca-page-bg">
        <div className="mca-ig-wrapper">
          <div className="mca-ig-container">
            <div className="mca-ig-overview-card">
              <div className="mca-ig-image-box">
                {/* --- WRAPPED IMAGE SRC WITH asset() --- */}
                <img
                  src={asset('/program/IMCA.webp')}
                  alt="Students studying"
                  className="mca-ig-hero-img"
                />
                <div className="mca-ig-image-overlay">
                  <div className="mca-ig-image-overlay-content">
                    <h3>Program Overview</h3>
                    <p>A comprehensive 5-year academic continuum for future IT leaders.</p>
                  </div>
                </div>
              </div>

              <div className="mca-ig-text-content">
                <p className="mca-ig-para">
                  The Integrated MCA (Master of Computer Applications) is a comprehensive 5-year program 
                  designed for students who have completed their 10+2 education and are looking to build a 
                  strong foundation in computer science, software development, and IT management. This 
                  program combines the undergraduate and postgraduate curriculum into a streamlined and 
                  focused academic journey, eliminating the need for separate entrance procedures for a 
                  master's degree.
                </p>

              </div>
            </div>

            <div className="mca-ig-grid">
              {keyFeatures.map((feature, index) => (
                <div key={index} className="mca-ig-card">
                  <div className="mca-ig-icon-wrapper">{feature.icon}</div>
                  <div className="mca-ig-card-info">
                    <h4>{feature.title}</h4>
                    <p>{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="mca-ig-stats-row">
            {/* Stats remain the same */}
            <div className="mca-ig-stat-item">
              <div className="mca-ig-stat-icon-wrapper"><BuildingIcon /></div>
              <div className="mca-ig-stat-text-box">
                <span className="mca-ig-stat-value">2025–26</span>
                <span className="mca-ig-stat-label">Establishment</span>
              </div>
            </div>
            <div className="mca-ig-stat-item">
              <div className="mca-ig-stat-icon-wrapper"><UsersIcon /></div>
              <div className="mca-ig-stat-text-box">
                <span className="mca-ig-stat-value">60</span>
                <span className="mca-ig-stat-label">Annual Intake</span>
              </div>
            </div>
            <div className="mca-ig-stat-item">
              <div className="mca-ig-stat-icon-wrapper"><GraduationIcon /></div>
              <div className="mca-ig-stat-text-box">
                <span className="mca-ig-stat-value">Postgraduate</span>
                <span className="mca-ig-stat-label">Program Level</span>
              </div>
            </div>
          </div>
        </div>
              <ContactAdmissionsStrip onAppointmentClick={() => setShowForm(true)} />

      </div>
      <Footer />
    </>
  );
}